/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Reducer for Settings components
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.1
 * @since 1.3.0
 */

import { combineReducers } from 'redux';

import { ISettingsLabelsState, settingsLabelsReducer } from './components/SettingsLabels/settingsLabelsReducer';
import {
    ISettingsPositionsState,
    settingsPositionsReducer,
} from './components/SettingsPositions/settingsPositionsReducer';
import { ISettingsProfileReducer, settingsProfileReducer } from './components/SettingsProfile/settingsProfileReducer';
import { ISettingsCommonReducer } from './PageSettingsTypes';
import { settingsCommonReducer } from './settingsCommonReducer';

export interface ISettingsReducer {
    profile: ISettingsProfileReducer;
    common: ISettingsCommonReducer;
    settingsLabels: ISettingsLabelsState;
    settingsPositions: ISettingsPositionsState;
}

const settingsReducer = () => combineReducers<ISettingsReducer>({
    profile: settingsProfileReducer,
    common: settingsCommonReducer,
    settingsLabels: settingsLabelsReducer,
    settingsPositions: settingsPositionsReducer,
});

export default settingsReducer;
